import { Color, Text } from '@billy/design-system'
import { Table } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { formatAmount } from '../../../../../../constants/LedgerEntriesTableCells'
import { TruncatedTextCell } from '../../../../../../elements/TruncatedTextCell'
import type { LedgerEntryColumnDef } from '../../../../../../hooks/useLedgerEntriesTableColumns'

interface TotalBalanceRowProps {
  columns: LedgerEntryColumnDef[]
  label: string
  totalBalance: number
}

export const TotalBalanceRow = ({ columns, label, totalBalance }: TotalBalanceRowProps): ReactElement => (
  <Table.Row highlighted>
    <Table.Cell colSpan={columns.length - 1}>
      <Text nowrap weight="semiBold">
        {label}
      </Text>
    </Table.Cell>
    <Table.Cell align={columns.at(-1)?.align}>
      <TruncatedTextCell
        color={totalBalance < 0 ? Color.Red700 : undefined}
        value={formatAmount(totalBalance)}
        weight="bold"
      />
    </Table.Cell>
  </Table.Row>
)
